import React from "react";
import { bool, func, object, oneOfType, shape } from "prop-types";

import ExpertsForm from "src/shared/contact-boxes/experts/components/ExpertsForm";
import Header from "src/shared/contact-boxes/experts/components/Header";
import Modal from "src/shared/contact-boxes/experts/components/Modal";

const MobileForm = ({ innerRef, isOpen, onClose, onSubmit }) => (
  <Modal
    data-qa="mobile-expert-contact-modal"
    isOpen={isOpen}
    onRequestClose={onClose}
    theme="classicBlueHeader"
  >
    <Modal.ModalTitle>
      <Header inModalHeader />
    </Modal.ModalTitle>
    <Modal.ModalBody>
      <ExpertsForm innerRef={innerRef} isModal onSubmit={onSubmit} />
    </Modal.ModalBody>
  </Modal>
);

MobileForm.propTypes = {
  innerRef: oneOfType([func, shape({ current: object })]),
  isOpen: bool,
  onClose: func,
  onSubmit: func
};

MobileForm.defaultProps = {
  innerRef: null,
  isOpen: false,
  onClose: () => null,
  onSubmit: () => null
};

export default MobileForm;
